import { SortOrder as SortDirection } from '@risk-first/ui-column-menu';
import { ApiSortDirection } from '../../types/ApiSortDirection';

export const sortDirectionToApiSortDirectionMap = new Map<SortDirection, ApiSortDirection>([
  [SortDirection.ASC, 'ASC'],
  [SortDirection.DESC, 'DESC'],
]);
